import { DataBean } from "../../DataBean";


export class Fingerprint extends DataBean {

    public async getFingerprint(acc: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getFingerprint_Number", [acc]);
    }
 public async addFingerprint(acc: any,handType:any,fingerType:any,media:any,context:any,dataStore:any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.account.Fingerprint_addFingerprint_Number_Number_Number_String_String_String", [acc,handType,fingerType,media,context,dataStore]);
    }

    public async deleteBioIdentity(idBioIdentity: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteBioIdentity_Number", [idBioIdentity]);
    }
}